import React, { useCallback, useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { pushNotification } from "utils/notifications";
import { formatNumber } from "utils/currencyFormat";

const ThemSuaThuocTinhGiamTru = ({
  onClose,
  onSave,
  data,
  listCauHinhTaiSan,
}) => {
  // console.log("Data: ", data);
  const [CauHinhTaiSanId, setCauHinhTaiSanId] = useState(
    data?.CauHinhTaiSanId != 0
      ? data?.CauHinhTaiSanId
      : listCauHinhTaiSan[0]?.CauHinhTaiSanId,
  );
  const [TenThuocTinh, setTenThuocTinh] = useState(data?.TenThuocTinh ?? "");
  const [TienGiamTru, setTienGiamTru] = useState(
    formatNumber(data?.TienGiamTru) ?? 0,
  );
  const [saving, setSaving] = useState(false);
  const [errors, setErrors] = useState({});

  const handleKeyDown = (event) => {
    if (event.key === "Escape") onClose();
  };
  useEffect(() => {
    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, []);
  const validate = () => {
    let newErrors = {};
    const numericTienGiamTru = Number(TienGiamTru.toString().replace(/,/g, ""));
    if (
      !numericTienGiamTru ||
      isNaN(numericTienGiamTru) ||
      numericTienGiamTru <= 0
    )
      newErrors.TienGiamTru = "Nhập giá trị hợp lệ";
    if (!TenThuocTinh.trim())
      newErrors.TenThuocTinh = "Hãy nhập tên thuộc tính";
    return newErrors;
  };
  const handleSave = async () => {
    const newErrors = validate();
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }
    const numericTienGiamTru = Number(TienGiamTru.toString().replace(/,/g, ""));
    setErrors({});

    setSaving(true);
    try {
      const payload = {
        ThuocTinhGiamTruId: data?.ThuocTinhGiamTruId ?? 0,
        CauHinhTaiSanId: parseInt(CauHinhTaiSanId),
        TenThuocTinh: TenThuocTinh.trim(),
        TienGiamTru: numericTienGiamTru,
        KeyThongTinGiamTru: data?.KeyThuocTinhGiamTru ?? "",
        isDel: data?.isDel ?? true,
      };
      // console.log("datasave payload: ", payload);
      await onSave(payload);
    } catch (err) {
      console.error("Lỗi khi lưu:", err);
      pushNotification(
        "Có lỗi xảy ra khi lưu. Vui lòng thử lại.",
        "error",
        "TOP_CENTER",
        1000,
      );
    } finally {
      setSaving(false);
    }
  };
  const handleValueChange = (e) => {
    let rawValue = e.target.value.replace(/\D/g, "");
    if (rawValue === "") {
      setTienGiamTru("");
      return;
    }
    const formatted = Number(rawValue).toLocaleString("en-US");
    setTienGiamTru(formatted);
  };

  return (
    <Modal
      show={true}
      size="lg"
      centered
      className="modal-new modal fade text-left"
      animation={true}
    >
      <Modal.Header>
        <h4 className="modal-title text-bold" style={{ paddingLeft: "15px" }}>
          {!data?.ThongTinGiamTruID || data.ThongTinGiamTruID === 0
            ? "Thêm mới thuộc tính giảm trừ"
            : "Sửa thuộc tính giảm trừ"}
        </h4>
        <button type="button" className="close-popup-new" onClick={onClose}>
          <i className="mdi mdi-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body>
        <div className="row" style={{ paddingTop: "5px" }}>
          <div className="col-md-6">
            <div className="form-group">
              <label>
                <span className="text-bold">Loại tài sản</span>
              </label>
              <select
                id="CauHinhTaiSanId"
                name="CauHinhTaiSanId"
                value={CauHinhTaiSanId}
                onChange={(e) => setCauHinhTaiSanId(e.target.value)}
                className="form-control input-sm"
              >
                {listCauHinhTaiSan &&
                  listCauHinhTaiSan.map((cauhinh, index) => (
                    <option key={index} value={cauhinh.CauHinhTaiSanId}>
                      {cauhinh.TenHangHoa}
                    </option>
                  ))}
              </select>
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>
                <span className="text-bold">Tên thuộc tính giảm trừ</span>
                <span className="text-danger">(*)</span>
              </label>
              <input
                type="text"
                className="form-control"
                value={TenThuocTinh}
                onChange={(e) => setTenThuocTinh(e.target.value)}
              />
              {errors.TenThuocTinh && (
                <div className="text-danger">{errors.TenThuocTinh}</div>
              )}
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>
                <span className="text-bold">Tiền giảm trừ</span>
                <span className="text-danger">(*)</span>
              </label>
              <input
                type="text"
                className="form-control"
                value={TienGiamTru}
                onChange={handleValueChange}
                placeholder="Ví dụ: Honda"
              />
              {errors.TienGiamTru && (
                <div className="text-danger">{errors.TienGiamTru}</div>
              )}
            </div>
          </div>
        </div>
      </Modal.Body>

      <Modal.Footer>
        <button
          className="btn btn-new-main btn-closenew"
          onClick={onClose}
          disabled={saving}
        >
          <i className="mdi mdi-close"></i>&nbsp; Đóng
        </button>
        <button
          className="btn "
          onClick={handleSave}
          disabled={saving}
          style={{
            background: "#056569",
            color: "white",
            borderRadius: "6px",
            fontSize: "15px",
            textTransform: "none",
          }}
        >
          {saving ? (
            <>
              <span className="spinner-border spinner-border-sm"></span>&nbsp;
              Đang lưu...
            </>
          ) : (
            <>
              <i className="mdi mdi-content-save"></i>&nbsp; Lưu
            </>
          )}
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default ThemSuaThuocTinhGiamTru;
